import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { isPast } from 'date-fns';
import { hash } from 'rsvp';

export default class StartRoute extends Route {
  @service router;
  @service store;
  @service session;

  beforeModel(transition) {
    // Redirect to onboarding due to deprecation of start flow
    this.router.transitionTo('onboarding');
    return;

    if (this.session.user && !this.session.user.confirmed) {
      this.router.transitionTo('confirm-account');
    }
    this.session.requireAuthentication();
    this.session.requireActive();
    if (isPast(this.session.user?.active_until))
      this.router.transitionTo('plans');
    if (transition.targetName === 'start.index')
      this.router.transitionTo('start');
  }

  deactivate() {
    this.controller.url = null;
    this.controller.urlId = null;
    this.controller.currentStep = 'url';
  }

  model(params) {
    return hash({
      url: params.urlId
        ? this.store.findRecord('url', params.urlId)
        : this.store.createRecord('url', {
            matchNestedUrls: true,
            matchSubdomains: false,
          }),
      urlGroups: this.store.query('url-group', { static: true }),
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.enteredRoute(model.url, model.urlGroups);
  }
}
